export default __webpack_public_path__ + "static/media/south_east_asia_circle.3712e31a.svg";